var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.743 1.92a.75.75 0 0 1 0 1.493l-.076.004H11.13l-4.583 9.166H8l.076.004a.75.75 0 0 1 0 1.492L8 14.083H3.333a.75.75 0 0 1 0-1.5H4.87l4.583-9.166H8a.75.75 0 0 1 0-1.5h4.667z"
  })));
};
export default Svg16;